import { useParams, Link, Navigate } from "react-router-dom";
import { posts } from "@/data/content";
import { ArrowLeft } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <main data-testid="blog-post-page" className="pt-32">
      <article className="max-w-3xl mx-auto px-6 md:px-12 pb-24">
        <Link
          to="/blog"
          data-testid="blog-back-link"
          className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-[#36C281] transition-colors mb-12"
        >
          <ArrowLeft size={14} /> Back to journal
        </Link>

        <div className="text-xs text-[#36C281] tracking-[0.2em] uppercase">{post.date}</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[1.1]">
          {post.title}
        </h1>

        <div className="mt-12 overflow-hidden border border-neutral-800">
          <img src={post.image} alt={post.title} className="w-full h-[420px] object-cover" />
        </div>

        <div className="mt-12 space-y-6">
          {post.body.map((para, i) => (
            <p key={i} className="text-neutral-300 leading-[1.85] text-lg">{para}</p>
          ))}
        </div>

        <div className="mt-20 border-t border-neutral-800 pt-10">
          <p className="text-neutral-400">
            Want this kind of thinking applied to your portfolio?{" "}
            <Link to="/#contact" className="text-[#36C281] hover:underline">
              Book a discovery call →
            </Link>
          </p>
        </div>
      </article>
    </main>
  );
}
